import {
  CardPayment,
  CloseCardCycleRequest,
  CcCharge,
  CreateCardPaymentRequest,
  CreateCcChargeRequest,
  CreditCard,
  InstallmentsResponse,
  ProjectionResponse,
  UpsertCreditCardRequest,
  UpdateCcChargeRequest,
} from '@financial/shared';
import type { AppCurrency } from '@financial/shared';
import { api } from '../../lib/api';

export interface CloseCycleResponse {
  advanced: number;
  cutoff: string;
  alreadyClosed: boolean;
  noNewCutoff?: boolean;
  statementPaymentForNoInterest?: number;
}

export async function getCard(currency?: AppCurrency): Promise<CreditCard | null> {
  const res = await api.get<CreditCard | null>('/credit-card', {
    params: currency ? { currency } : undefined,
  });
  return res.data;
}

export async function upsertCard(body: UpsertCreditCardRequest): Promise<CreditCard> {
  const res = await api.put<CreditCard>('/credit-card', body);
  return res.data;
}

export async function listCharges(): Promise<CcCharge[]> {
  const res = await api.get<CcCharge[]>('/credit-card/charges');
  return res.data;
}

export async function createCharge(body: CreateCcChargeRequest): Promise<CcCharge> {
  const res = await api.post<CcCharge>('/credit-card/charges', body);
  return res.data;
}

export async function updateCharge(id: string, body: UpdateCcChargeRequest): Promise<CcCharge> {
  const res = await api.patch<CcCharge>(`/credit-card/charges/${id}`, body);
  return res.data;
}

export async function deleteCharge(id: string): Promise<void> {
  await api.delete(`/credit-card/charges/${id}`);
}

export async function getInstallments(): Promise<InstallmentsResponse> {
  const res = await api.get<InstallmentsResponse>('/credit-card/installments');
  return res.data;
}

export async function getProjection(): Promise<ProjectionResponse> {
  const res = await api.get<ProjectionResponse>('/credit-card/projection');
  return res.data;
}

export async function closeCycle(body: CloseCardCycleRequest): Promise<CloseCycleResponse> {
  const res = await api.post<CloseCycleResponse>('/credit-card/close-cycle', body);
  return res.data;
}

export async function listPayments(): Promise<CardPayment[]> {
  const res = await api.get<CardPayment[]>('/credit-card/payments');
  return res.data;
}

export async function createPayment(body: CreateCardPaymentRequest): Promise<CardPayment> {
  const res = await api.post<CardPayment>('/credit-card/payments', body);
  return res.data;
}

export async function deletePayment(id: string): Promise<void> {
  await api.delete(`/credit-card/payments/${id}`);
}
